import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';

import AddressBookContent from './AddressBookContent';

import { addresses, sapAddresses, sidebarOpen } from './selectors';
import { requestAddresses } from './actions';
import { getUserAccount, getUserData } from '../user/selectors';

import { addressTypes } from '../types/address';
import { userTypes } from '../types/user';

export class AddressBook extends Component {
  fetchAddresses = () => {
    const { requestAddresses, user } = this.props;

    if (user) {
      requestAddresses();
    }
  };

  render() {
    const { addresses, sapAddresses, sidebarOpen } = this.props;
    return (
      <div className={classnames('addressbook__main_outer', { sidebarOpen: sidebarOpen })}>
        <AddressBookContent addresses={addresses} sapAddresses={sapAddresses} fetchAddresses={this.fetchAddresses} />
      </div>
    );
  }
}

AddressBook.propTypes = {
  sidebarOpen: PropTypes.bool.isRequired,
  user: userTypes.isRequired,
  addresses: PropTypes.arrayOf(PropTypes.shape(addressTypes)),
  requestAddresses: PropTypes.func.isRequired,
  sapAddresses: PropTypes.arrayOf(PropTypes.shape(addressTypes))
};

AddressBook.defaultProps = {
  addresses: null,
  sapAddresses: null
};

const mapStateToProps = state => ({
  addresses: addresses(state),
  sapAddresses: sapAddresses(state),
  sidebarOpen: sidebarOpen(state),
  user: getUserData(state),
  userAccount: getUserAccount(state)
});

const connector = connect(mapStateToProps, { requestAddresses });

export default connector(AddressBook);
